export default {
  shared_breadcrumb_home: "Início",
  shared_breadcrumb_quotations: "Meus Serviços",
  shared_breadcrumb_equipments: "Equipamentos",
  shared_breadcrumb_quote_service: "Solicitar Cotação",
  shared_breadcrumb_details: "Detalhes",
  shared_breadcrumb_shipping: "Instruções de Envio",
  shared_breadcrumb_back_btn: "Voltar",
  shared_details_attention_label: "Atenção",
  shared_details_select_file_warning: "Por favor, selecione um arquivo para upload.",
  shared_details_enter_name_warning: "Por favor, informe um nome para a nota fiscal.",
  shared_details_remove_invoice_title: "Remover Nota Fiscal?",
  shared_details_remove_invoice_warning: "Esta ação não poderá ser desfeita.",
  shared_details_remove_invoice_confirm_btn: "Sim, remover",
  shared_details_cancel_btn: "Cancelar",
  shared_details_download_info_msg: "O arquivo #vr0# sera baixado.",
  shared_details_invoices_title: "🧾 Notas Fiscais de Remessa",
  shared_details_attach_invoice_btn: "Anexar Nota Fiscal",
  shared_details_no_invoices_msg: "Nenhuma nota fiscal anexada.",
  shared_details_download_tooltip: "Baixar/Visualizar",
  shared_details_delete_tooltip: "Excluir",
  shared_details_attach_modal_title: "Adicionar Nota Fiscal (PDF ou XML)",
  shared_details_invoice_name_label: "Nome da Nota Fiscal",
  shared_details_invoice_name_placeholder: "Ex: NF-e 12345",
  shared_details_select_file_msg: "Clique para selecionar o arquivo",
  shared_details_file_size_label: "Tamanho:",
  shared_details_uploading_btn: "Enviando...",
  shared_details_save_btn: "Salvar",
  shared_flat_list_empty_msg: "Nenhum item encontrado",
  shared_flat_list_no_title: "Sem título",
  shared_flat_table_empty_msg: "Nenhum registro encontrado",
  shared_cliente_company_label: "Empresa:",
  shared_cliente_phone_label: "Telefone:",
  shared_cliente_cnpj_label: "CNPJ:",
  shared_cliente_email_label: "E-mail:",
  shared_orcamento_status_label: "Status:",
  shared_quotation_card_waiting: "Orçamento em análise",
  shared_quotation_card_details_btn: "Detalhes",
  shared_quotation_column_no_quotes: "Nenhuma cotação nesta coluna",
  shared_quotation_column_show_less: "Mostrar menos",
  shared_quotation_column_show_more: "Ver mais (#vr0# restantes)",
  shared_quotation_section_show_hide: "Mostrar/Ocultar",
  shared_estimate_respond_no_estimate: "Nenhuma estimativa carregada.",
  shared_estimate_respond_no_item: "Nenhum item",
  shared_estimate_respond_obs_label: "Observação adicional",
  shared_estimate_respond_obs_placeholder: "Digite a resposta...",
  shared_estimate_respond_total_label: "Valor Total",
  shared_estimate_respond_finish_btn: "Finalizar Resposta",
  shared_estimate_respond_item_details: "Detalhes do Item",
  shared_estimate_respond_select_service: "Selecionar Serviço / Peça",
  shared_estimate_respond_filter_label: "Filtrar",
  shared_estimate_respond_filter_placeholder: "Digite para filtrar...",
  shared_estimate_respond_qty_label: "Quantidade",
  shared_estimate_respond_price1_label: "Preço 1",
  shared_estimate_respond_price2_label: "Preço 2",
  shared_estimate_respond_back_btn: "Voltar",
  shared_estimate_respond_add_btn: "Adicionar",
  shared_estimate_respond_close_btn: "Fechar",
  shared_resp_no_client_msg: "Nenhum cliente carregado.",
  shared_resp_client_company: "Empresa",
  shared_resp_client_name: "Nome",
  shared_resp_client_phone: "Telefone",
  shared_resp_client_cnpj: "CNPJ",
  shared_resp_client_date: "Data",
  shared_resp_client_email: "E-mail",
  shared_resp_form_items_added: "Itens adicionados",
  shared_resp_form_obs_label: "Observação adicional",
  shared_resp_form_placeholder: "Digite a resposta...",
  shared_resp_modal_price: "Preço",
  shared_accept_estimate_accepted_title: "Estimativa Aceita!",
  shared_accept_estimate_process_error: "Não foi possível processar a solicitação.",
  shared_accept_estimate_modal_title: "✅ Aceitar Estimativa",
  shared_accept_estimate_processing_btn: "Processando...",
  shared_accept_estimate_confirm_btn: "Confirmar Aceite",
  shared_accept_estimate_description: "Ao confirmar, sua estimativa será aceita e seguirá para o próximo status do fluxo.",
  shared_accept_estimate_simple_success_msg: "O aceite da estimativa foi registrado com sucesso.",
  shared_service_msg_equip_updated: "Equipamento atualizado!",
  shared_service_msg_equip_created: "Equipamento cadastrado!",
  shared_service_msg_equip_save_error: "Erro ao salvar equipamento",
  shared_service_msg_photo_uploaded: "Foto enviada!",
  shared_service_msg_photo_upload_error: "Erro ao enviar foto",
  shared_service_msg_photo_removed: "Foto removida!",
  shared_service_msg_photo_remove_error: "Erro ao remover foto",
  shared_service_msg_laudo_uploaded: "Laudo enviado!",
  shared_service_msg_laudo_upload_error: "Erro ao enviar laudo",
  shared_service_msg_laudo_removed: "Laudo removido!",
  shared_service_msg_laudo_remove_error: "Erro ao remover laudo",
  shared_clients_add_btn: "Adicionar",
  shared_clients_address_label: "Endereço",
  shared_clients_address_placeholder: "Ex: Rua das Flores, 123 - Centro",
  shared_clients_cnpj_invalid: "CNPJ inválido",
  shared_clients_cnpj_label: "CNPJ",
  shared_clients_cnpj_placeholder: "Ex: 12.345.678/0001-90",
  shared_clients_cnpj_required: "CNPJ é obrigatório",
  shared_clients_cpf_invalid: "CPF inválido",
  shared_clients_cpf_label: "CPF",
  shared_clients_cpf_placeholder: "Ex: 123.456.789-00",
  shared_clients_cpf_required: "CPF é obrigatório",
  shared_clients_create_btn: "Criar Cliente",
  shared_clients_delete_btn: "Deletar",
  shared_clients_delete_confirm_title: "Confirmar Deleção",
  shared_clients_delete_warning: "Tem certeza que deseja excluir {{name}}?",
  shared_clients_edit_btn: "Editar",
  shared_clients_edit_title: "Editar Cliente",
  shared_clients_email_invalid: "E-mail inválido",
  shared_clients_email_placeholder: "Ex: contato@empresa.com.br",
  shared_clients_filter_doc_placeholder: "Filtrar por CPF/CNPJ...",
  shared_clients_filter_name_placeholder: "Filtrar por nome...",
  shared_clients_modal_title: "Clientes",
  shared_clients_name_placeholder: "Ex: Empresa LTDA ou João Silva",
  shared_clients_name_required: "Nome / Razão Social é obrigatório",
  shared_clients_new_title: "Novo Cliente",
  shared_clients_no_clients_found: "Nenhum cliente encontrado",
  shared_clients_obs_placeholder: "Informações adicionais sobre o cliente",
  shared_clients_pagination_next: "Próximo",
  shared_clients_pf_label: "Pessoa Física",
  shared_clients_phone_placeholder: "Ex: (11) 99999-8888",
  shared_clients_pj_label: "Pessoa Jurídica",
  shared_clients_save_changes_btn: "Salvar Alterações",
  shared_clients_table_actions: "Ações",
  shared_clients_table_document: "CPF / CNPJ",
  shared_clients_table_name: "Nome / Razão Social",
  shared_clients_table_type: "Tipo",
  shared_clients_type_required: "Tipo é obrigatório",
  shared_details_add_btn: "Adicionar",
  shared_details_btn: "Detalhes",
  shared_details_close_btn: "Fechar",
  shared_details_cnpj_label: "CNPJ:",
  shared_details_company_label: "Empresa:",
  shared_details_date_label: "Data:",
  shared_details_email_label: "E-mail:",
  shared_details_error_label: "Erro",
  shared_details_name_label: "Nome:",
  shared_details_no_btn: "Não",
  shared_details_no_client_msg: "Nenhum cliente encontrado.",
  shared_details_phone_label: "Telefone:",
  shared_details_see_more_btn: "Ver Mais",
  shared_details_success_label: "Sucesso",
  shared_details_view_btn: "Visualizar",
  shared_details_warning_label: "Aviso",
  shared_details_yes_btn: "Sim",
  shared_edit_btn: "Editar",
  shared_equip_brand_label: "Marca:",
  shared_equip_ca_label: "CA:",
  shared_equip_card_code_label: "Cód",
  shared_equip_card_details_btn: "Detalhes",
  shared_equip_card_item_label: "Item",
  shared_equip_card_last_rev_label: "Últ. Revisão",
  shared_equip_card_next_rev_label: "Próx. Revisão",
  shared_equip_card_pending_status: "PENDENTE",
  shared_equip_download_label: "Download",
  shared_equip_form_active_label: "Ativo",
  shared_equip_form_add_photo_after_btn: "Adicionar Foto Depois",
  shared_equip_form_add_photo_before_btn: "Adicionar Foto Antes",
  shared_equip_form_attention_label: "Atenção",
  shared_equip_form_back_btn: "Voltar",
  shared_equip_form_brand_label: "Marca",
  shared_equip_form_ca_label: "CA",
  shared_equip_form_cancel_btn: "Cancelar",
  shared_equip_form_close_btn: "Fechar",
  shared_equip_form_data_section_title: "📌 Dados do Equipamento",
  shared_equip_form_deactivate_warning: "Esse equipamento será permanentemente removido caso salve a alteração.",
  shared_equip_form_delete_photo_error: "Não foi possível excluir a foto",
  shared_equip_form_error_label: "Erro",
  shared_equip_form_last_rev_label: "Última Revisão",
  shared_equip_form_laudo_default_desc: "Laudo enviado pelo sistema",
  shared_equip_form_laudo_default_name: "Laudo tecnico",
  shared_equip_form_laudo_name_prompt: "Nome do laudo",
  shared_equip_form_laudos_section_title: "📑 Laudos",
  shared_equip_form_loading_msg: "Carregando...",
  shared_equip_form_location_label: "Localização",
  shared_equip_form_model_label: "Modelo",
  shared_equip_form_next_rev_label: "Próxima Revisão",
  shared_equip_form_no_btn: "Não",
  shared_equip_form_obs_label: "Observação Técnica",
  shared_equip_form_photos_section_title: "📷 Fotos",
  shared_equip_form_remove_laudo_title: "Remover este laudo?",
  shared_equip_form_remove_photo_title: "Remover esta foto?",
  shared_equip_form_save_btn: "Salvar",
  shared_equip_form_save_changes_btn: "Salvar Alterações",
  shared_equip_form_save_equip_btn: "Salvar Equipamento",
  shared_equip_form_save_error: "Não foi possível salvar o equipamento",
  shared_equip_form_save_first_laudos_msg: "Salve o equipamento primeiro para adicionar laudos.",
  shared_equip_form_save_first_photos_msg: "Salve o equipamento primeiro para adicionar fotos.",
  shared_equip_form_save_first_warning: "Atenção",
  shared_equip_form_saving_btn: "Salvando...",
  shared_equip_form_search_placeholder: "Digite para buscar serviço",
  shared_equip_form_select_service_error: "Erro",
  shared_equip_form_send_laudo_btn: "Enviar Laudo (PDF)",
  shared_equip_form_serial_label: "Série",
  shared_equip_form_service_label: "Serviço vinculado",
  shared_equip_form_success_label: "Sucesso",
  shared_equip_form_understand_btn: "Entendi",
  shared_equip_form_upload_laudo_error: "Não foi possível enviar o laudo",
  shared_equip_form_upload_photo_error: "Não foi possível enviar a foto",
  shared_equip_form_yes_btn: "Sim",
  shared_equip_item_label: "Item:",
  shared_equip_last_rev_label: "Última Rev.:",
  shared_equip_modal_title: "Cadastro Rápido de Equipamento",
  shared_equip_model_label: "Modelo:",
  shared_equip_next_rev_label: "Próxima Rev.:",
  shared_equip_no_history_msg: "Nenhum laudo cadastrado.",
  shared_equip_no_photos_msg: "Nenhuma foto cadastrada.",
  shared_equip_pending_revision_label: "🔴 Revisão pendente",
  shared_equip_photo_alt: "Foto do equipamento",
  shared_equip_qr_code_label: "QR Code:",
  shared_equip_serial_label: "Série:",
  shared_image_modal_alt: "Imagem modal alt",
  shared_menu_add_equipment: "Adicionar Equipamento",
  shared_menu_equipments: "Equipamentos",
  shared_optional_label: "Opcional",
  shared_quotation_client_label: "Cliente",
  shared_quotation_doc_num: "Núm.Doc:",
  shared_quotation_table_status: "Status",
}
